import { useAuthStore } from '@/stores/auth.store'
import { Outlet, createRoute, redirect } from '@tanstack/react-router'
import { Route as rootRoute } from '../__root'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: 'auth-layout',
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <main className="min-h-dvh bg-muted">
      <Outlet />
    </main>
  )
}
